module.exports = __webpack_public_path__ + "static/media/mindfulness-large@3x.c4a5c9a6.png";